module.exports = __webpack_public_path__ + "img/background_c3-1-2.035acfd5.png";